import { render } from "./UserProfileConfig.vue?vue&type=template&id=a56b557c"
import script from "./UserProfileConfig.vue?vue&type=script&lang=js"
export * from "./UserProfileConfig.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__